import {Grid} from '@mui/material';
import TextAreaComponent from '../../../common/TextAreaComponent/TextAreaComponent';
import {t} from 'i18next';
import './CaseContextAndCriteria.scss';
import {CRITERIA} from '../issue-coding-type-header/IssueCodingTypeHeader';
import {
  setEditMode,
  setFormData,
} from '../../../../../../redux/slice/aiReviewSlice';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../../../redux/store';
import {
  MAX_HEIGHT,
  MIN_HEIGHT,
  PROTOCOL_INTELLIGENCE_FIELDS,
} from '../../../constant/AiReviewConstants';

const CaseContextAndCriteria = ({
  handleUseSavedProtocol,
}: {
  handleUseSavedProtocol: (value?: string) => void;
}) => {
  const formData = useSelector((state: RootState) => state.aiReview.formData);
  const editMode = useSelector((state: RootState) => state.aiReview.editMode);

  const defineCriteria = useSelector(
    (state: RootState) => state.aiReview.defineCriteria
  );
  const dispatch = useDispatch();

  const handleCaseContextChange = (value: string) => {
    if (defineCriteria === CRITERIA.SAVED) {
      dispatch(setEditMode({caseContext: true}));
    }
    if (value.length <= 10000)
      dispatch(
        setFormData({
          contextAndCriteria: {
            ...formData.contextAndCriteria,
            context: value,
          },
        })
      );
  };

  const handleRelevanceCriteriaChange = (value: string) => {
    if (defineCriteria === CRITERIA.SAVED) {
      dispatch(setEditMode({relevanceCriteria: true}));
    }
    if (value.length <= 10000)
      dispatch(
        setFormData({
          contextAndCriteria: {
            ...formData.contextAndCriteria,
            relevanceCriteria: value,
          },
        })
      );
  };

  return (
    <Grid className="case-context-container" container spacing={3}>
      <Grid size={{xs: 12, md: 6}}>
        <TextAreaComponent
          IsDefaultValueMinHeight={window.innerWidth <= 800}
          resizable
          displayHandle
          placeholder={t('ai.review.contextAndCriteria.caseContextPlaceholder')}
          label={t('ai.review.contextAndCriteria.caseContext')}
          data-testid="contextAndCriteria-caseContext-input"
          value={formData.contextAndCriteria.context}
          maxLength={10000}
          helperText={`${formData.contextAndCriteria.context?.length.toLocaleString()} / 10,000`}
          onChange={handleCaseContextChange}
          displayOptionalLabel={false}
          displayArrTooltip={true}
          toolTipTitle={t(
            'ai.review.contextAndCriteria.caseContextToolTipTitle'
          )}
          toolTipContent={t(
            'ai.review.contextAndCriteria.caseContextToolTipDescription'
          )}
          enableBanner={
            formData.contextAndCriteria.context !== '' &&
            defineCriteria === CRITERIA.SAVED
          }
          isEditMode={defineCriteria === CRITERIA.SAVED && editMode.caseContext}
          bannerContent={
            editMode.caseContext
              ? t('ai.review.contextAndCriteria.editBannerContent')
              : t('ai.review.contextAndCriteria.caseContextSavedBannerContent')
          }
          bannerAction={() => {
            dispatch(setEditMode({caseContext: false}));
            handleUseSavedProtocol(PROTOCOL_INTELLIGENCE_FIELDS.caseContext);
          }}
          MAX_HEIGHT={MAX_HEIGHT}
          MIN_HEIGHT={MIN_HEIGHT}
          tabIndex={0}
          aria-live="polite"
        />
      </Grid>
      <Grid size={{xs: 12, md: 6}}>
        <TextAreaComponent
          IsDefaultValueMinHeight={window.innerWidth <= 800}
          resizable
          displayHandle
          placeholder={t(
            'ai.review.contextAndCriteria.relevanceCriteriaPlaceholder'
          )}
          label={t('ai.review.contextAndCriteria.relevanceCriteria')}
          data-testid="contextAndCriteria-relevanceCriteria-input"
          value={formData.contextAndCriteria.relevanceCriteria}
          maxLength={10000}
          helperText={`${formData.contextAndCriteria.relevanceCriteria?.length.toLocaleString()} / 10,000`}
          onChange={handleRelevanceCriteriaChange}
          displayOptionalLabel={false}
          displayArrTooltip={true}
          toolTipTitle={t(
            'ai.review.contextAndCriteria.relevanceCriteriaToolTipTitle'
          )}
          toolTipContent={t(
            'ai.review.contextAndCriteria.relevanceCriteriaToolTipDescription'
          )}
          enableBanner={
            formData.contextAndCriteria.relevanceCriteria !== '' &&
            defineCriteria === CRITERIA.SAVED
          }
          isEditMode={
            defineCriteria === CRITERIA.SAVED && editMode.relevanceCriteria
          }
          bannerContent={
            editMode.relevanceCriteria
              ? t('ai.review.contextAndCriteria.editBannerContent')
              : t(
                  'ai.review.contextAndCriteria.relevanceCriteriaSavedBannerContent'
                )
          }
          bannerAction={() => {
            dispatch(setEditMode({relevanceCriteria: false}));
            handleUseSavedProtocol(
              PROTOCOL_INTELLIGENCE_FIELDS.relevanceCriteria
            );
          }}
          MAX_HEIGHT={MAX_HEIGHT}
          MIN_HEIGHT={MIN_HEIGHT}
          tabIndex={0}
          aria-live="polite"
        />
      </Grid>
    </Grid>
  );
};

export default CaseContextAndCriteria;
